export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          <div>
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
              HIPOBUY
            </h3>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Your comprehensive resource for organized product discovery, shopping guides, and verified spreadsheet information across all major platforms.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/40 transition-all"
              >
                <i className="ri-global-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/40 transition-all"
              >
                <i className="ri-shopping-bag-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/40 transition-all"
              >
                <i className="ri-links-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/40 transition-all"
              >
                <i className="ri-star-line"></i>
              </a>
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <p className="text-white/40 text-xs font-label tracking-wider uppercase mb-2">Quick Links</p>
              <div className="space-y-2">
                <p><a href="/" className="text-white/60 text-sm hover:text-white transition-colors">Home</a></p>
                <p><a href="#categories" className="text-white/60 text-sm hover:text-white transition-colors">Categories</a></p>
                <p><a href="/hipobuy-spreadsheet-guide" className="text-white/60 text-sm hover:text-white transition-colors">Hipobuy Guide</a></p>
                <p><a href="/kakobuy-spreadsheet-guide" className="text-white/60 text-sm hover:text-white transition-colors">Kakobuy Guide</a></p>
                <p><a href="/cssbuy-spreadsheet-guide" className="text-white/60 text-sm hover:text-white transition-colors">CSSBuy Guide</a></p>
                <p><a href="/superbuy-spreadsheet-guide" className="text-white/60 text-sm hover:text-white transition-colors">Superbuy Guide</a></p>
                <p><a href="/oopbuy-spreadsheet-guide" className="text-white/60 text-sm hover:text-white transition-colors">Oopbuy Guide</a></p>
                <p><a href="#about" className="text-white/60 text-sm hover:text-white transition-colors">About</a></p>
              </div>
            </div>
            <div>
              <p className="text-white/40 text-xs font-label tracking-wider uppercase mb-2">External Resources</p>
              <div className="space-y-2">
                <p><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors">Hipobuy Sheet</a></p>
                <p><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors">Buy It Now</a></p>
              </div>
            </div>
          </div>

          <div>
            <p className="text-white/40 text-xs font-label tracking-wider uppercase mb-4">Contact &amp; Info</p>
            <div className="space-y-4">
              <div>
                <p className="text-white/50 text-xs font-label tracking-wider uppercase">Address</p>
                <p className="text-white/70 text-sm mt-1">Online Platform</p>
                <p className="text-white/70 text-sm">United States</p>
              </div>
              <div>
                <p className="text-white/50 text-xs font-label tracking-wider uppercase">Platform</p>
                <p className="text-white/70 text-sm mt-1">hipobuyspread.org</p>
              </div>
              <div>
                <p className="text-white/50 text-xs font-label tracking-wider uppercase">Main Site</p>
                <p className="text-white/70 text-sm mt-1">kaspreadsheet.com</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; 2026 hipobuyspread.org. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="/" className="text-white/40 text-xs hover:text-white/70 transition-colors">Privacy</a>
            <a href="/" className="text-white/40 text-xs hover:text-white/70 transition-colors">Terms</a>
            <a href="/" className="text-white/40 text-xs hover:text-white/70 transition-colors">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}